<template>
  <b-form-group
    :id="formGroupId"
    :key="id"
    :label="label"
    :label-for="id"
    label-class="label-bold"
    :invalid-feedback="errorMsg"
    :state="state"
  >
    <b-input-group>
      <b-form-input
        :id="id"
        :key="id"
        :type="inputType"
        :maxlength="maxLength"
        placeholder="Password"
        @input="$emit('password-value-input', password)"
        v-model="password"
        :state="state"
        trim
      ></b-form-input>
      <b-input-group-append>
        <span
          class="input-group-text bg-white text-primary password-toggle"
          @click="togglePasswordReveal"
        >
          <i
            :class="passwordIconClass"
            id="toggle-show-pw"
            aria-hidden="true"
          ></i>
        </span>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: 'PasswordField',
  // props: ['id', 'label', 'state', 'errorMsg'],
  props: {
    id: String,
    label: String,
    state: Boolean,
    errorMsg: String,
    maxLength: {
      type: Number,
      default: 35,
    },
  },
  data: function () {
    return {
      inputType: 'password',
      password: '',
    };
  },

  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },
    passwordIconClass: function () {
      return {
        fa: true,
        'text-form-accent': true,
        'fa-eye': this.inputType == 'password' ? true : false,
        'fa-eye-slash': this.inputType == 'text' ? true : false,
      };
    },
  },

  methods: {
    togglePasswordReveal: function () {
      this.inputType = this.inputType == 'password' ? 'text' : 'password';
    },
  },
};
</script>

<style>
</style>